import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function OnboardingDataCompanySchema() {
  const { t } = useTranslation('validation');

  return z.object({
    document: z.string().min(1, t('notEmpty')),
    name: z.string().min(1, t('notEmpty')),
    fantasyName: z.string().optional(),
    postalCode: z.string().min(1, t('notEmpty')),
    number: z.string().min(1, t('notEmpty')),
    complement: z.string().optional(),
    phone: z.string().min(1, t('notEmpty')),
    email: z.string().min(1, t('notEmpty')),
    street: z.string().min(1, t('notEmpty')),
    district: z.string().min(1, t('notEmpty')),
    city: z.string().min(1, t('notEmpty')),
    state: z.string().min(1, t('notEmpty')),
  });
}

export type IOnboardingDataCompanyForm = z.infer<
  ReturnType<typeof OnboardingDataCompanySchema>
>;
